// extracted by mini-css-extract-plugin
module.exports = {"item":"ib","dark":"ic","light":"id","toggle":"ie"};